const isProduction = () => process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
const isStaging = () => process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
const isDevelopment = () => process.env.NEXT_PUBLIC_ENVIRONMENT === 'development'
const isLocal = () => process.env.NODE_ENV === 'development'

export const buildEnv = {
  isProduction,
  isStaging,
  isDevelopment,
  isLocal,
}
